<template>
  <div id="sidebar" class="leaflet-sidebar collapsed">
    <!-- Sidebar navigation -->
    <div class="leaflet-sidebar-tabs">
      <!-- Top aligned tabs -->
      <ul role="tablist">
        <li><a href="#stats" role="tab">
            <v-icon>query_stats</v-icon>
          </a></li>
        <li><a href="#filter" role="tab">
            <v-icon>filter_alt</v-icon>
          </a></li>
        <li v-if="poiList"><a href="#poi" role="tab">
            <v-icon>push_pin</v-icon>
          </a></li>
      </ul>

      <!-- Bottom aligned tabs -->
      <ul role="tablist">
        <li><a href="#config" role="tab">
            <v-icon>settings</v-icon>
          </a></li>
      </ul>
    </div>

    <!-- Sidebar panel content -->
    <div class="leaflet-sidebar-content">
      <div class="leaflet-sidebar-pane" id="stats">
        <h1>
          Statistics
        </h1>
        <DeviceStatusStats :items="items" />
      </div>

      <div class="leaflet-sidebar-pane" id="filter">
        <h1>
          Filtering
        </h1>
        <v-tabs v-model="filtertab" ref="tabs">
          <v-tab key="zone">
            Zone
          </v-tab>
          <v-tab key="severity">
            Severity
          </v-tab>
          <v-tab-item key="zone">
            <v-treeview selectable return-object v-model="zoneTreeModel" :items="zoneTree"></v-treeview>
          </v-tab-item>
          <v-tab-item key="severity">
            <v-treeview selectable return-object v-model="severityTreeModel" :items="severityTree"></v-treeview>
          </v-tab-item>
        </v-tabs>
      </div>

      <div class="leaflet-sidebar-pane" id="poi">
        <h1>
          Points of Interest
        </h1>
        <v-btn block color="primary" @click="$emit('fitToBounds')">Fit to Bounds</v-btn>
        <v-btn v-for="location in poiList" :key="location.name" block
          @click="$emit('moveToCoords', location.latitude, location.longitude, location.zoom)">{{location.name}}</v-btn>
      </div>

      <div class="leaflet-sidebar-pane" id="config">
        <h1>
          Config
        </h1>
        <ul>
          <li>
            <input type="checkbox" id="enable-clustering" checked
              @change="$emit('clusteringStateUpdate',$event.target.checked)" />
            <label for="enable-clustering">Enable Clustering</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceStatusStats from './DeviceStatusStats.vue'

export default {
  name: 'MapSidebar',
  components: { DeviceStatusStats },
  props: {
    items: Array,
    zoneTree: Array
  },
  computed: {
    /**
     * Get list of points of interest from frontend config
     *
     * @returns {Object[]}
     */
    poiList () {
      return this.$store.state.config.vueFrontendConfig.devicestatuspoi
    },
    /**
     * Compute devicetype list after filter has been applied
     */
    selectedDevicetypes () {
      return this.zoneTreeModel.filter(x => !('children' in x)).map(x => x.name)
    },
    /**
     * Compute severity list after filter has been applied
     */
    selectedSeverities () {
      return this.severityTreeModel.map(x => x.id)
    }
  },
  data () {
    return {
      filtertab: 0,
      zoneTreeModel: [],
      severityTreeModel: [],
      severityTree: [
        { id: 0, name: 'Normal' },
        { id: 1, name: 'Info' },
        { id: 2, name: 'Warning' },
        { id: 3, name: 'Minor' },
        { id: 4, name: 'Major' },
        { id: 5, name: 'Critical' }
      ]
    }
  },
  watch: {
    zoneTree (newZoneTree, oldZoneTree) {
      if (!oldZoneTree) { this.zoneTreeModel = newZoneTree }
    },
    /**
     * Update items on the map on device type filter change
     */
    selectedDevicetypes () {
      this.emitFilterUpdate()
    },
    /**
     * Update items on the map on severity filter change
     */
    selectedSeverities () {
      this.emitFilterUpdate()
    }
  },
  emits: ['filterUpdate', 'fitToBounds', 'moveToCoords', 'clusteringStateUpdate'],
  methods: {
    /**
     * Package filter values for passing to the map
     *
     * @returns {Object}
     */
    getTreeValues () {
      return { selectedDevicetypes: this.selectedDevicetypes, selectedSeverities: this.selectedSeverities }
    },
    /**
     * Emit an event to trigger the update of items on the map
     */
    emitFilterUpdate () {
      this.$emit('filterUpdate', this.getTreeValues())
    }
  },
  mounted () {
    this.severityTreeModel = this.severityTree
  }
}
</script>

<style>

</style>
